import type { SearchClient } from 'algoliasearch';
import type { InstantSearchOptions } from 'instantsearch.js';

import { useInstantSearchIndexName, useSearchClient } from '#src/app/pages/search/shared/hooks';

import { useRouting } from './hooks/useRouting';

type Result = ModelHookResult<{
	instantSearchIndexName: string;
	searchClient: SearchClient;
	routing: InstantSearchOptions['routing'];
}>;

export function useLayout(): Result {
	const {
		data: { searchClient },
	} = useSearchClient();

	const {
		data: { routing },
	} = useRouting();

	const {
		data: { instantSearchIndexName },
	} = useInstantSearchIndexName();

	return {
		data: {
			instantSearchIndexName,
			searchClient,
			routing,
		},
	};
}
